<script>
/*jshint esversion: 6 */ 
import {watch, computed, inject, ref} from 'vue';
import './../func.common';
import { FontAwesomeIcon, FontAwesomeLayers} from "@fortawesome/vue-fontawesome";
export default {
    name: 'treeSelect',
    components: {
        'font-awesome-icon' : FontAwesomeIcon,
        'font-awesome-layers' : FontAwesomeLayers,
    },
    props: {
        'disabled': {type: Boolean},
        'fullSchema': { type: [Object], default: function() { return {};} }, 
        'hinted': {type: String},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    },
    setup(props, ctx) {
        const validateChild = inject('validateChild');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });


        watch(() => helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator,
            };
            if (validateChild) {
                validateChild(toParent);
            }
        }, {deep:true});
    }
}
</script>
<template lang="pug">
.vueFormFieldMain
    .jobSectorMain.mt-4(
       :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
    )
        label(v-if="schema.label && schema.label.length > 0" v-html="schema.label")
        .row(:style="disabled === true ? 'opacity: 0.5; cursor:not-allowed': ''")
            .col-12
                label {{schema.mainLabel}}
                span.redAst(v-if="schema.required === true") *
            .col-12
                treeselect(
                    v-model="model[schema.model]"
                    :multiple="schema.multiselect" 
                    :options="schema.values"
                    :placeholder="schema.placeholder"
                    :disable-branch-nodes="true"
                    search-nested
                )
                    template(#value-label="{ node }")
                        div {{ node.raw.customLabel }}
                    template(#control-arrow="{ showArrow, menuIsOpen, arrowClass }")
                        span(v-if="showArrow" :class="schema.arrowClass")
                            template(v-if="menuIsOpen") 
                                font-awesome-icon(:icon="schema.iconOpen") 
                            template(v-if="!menuIsOpen")
                                font-awesome-icon(:icon="schema.iconClose") 
        .form-group.row.gy-2.gx-3-align-items-left
            .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
            .vueFormSmall.labelred(v-if="schema.errorShow === true")
                font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                | &nbsp;{{ schema.errorText[0] }}
</template>
